import { useEffect, useState } from 'react';

/** A value that follows `value` only after it has stopped changing for `ms` — so typing is one search, not one per key. */
export function useDebounced<T>(value: T, ms: number): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setSettled(value), ms);
    return () => clearTimeout(id);
  }, [value, ms]);
  return settled;
}
